export default __webpack_public_path__ + "static/media/Vector back.40dd549a.svg";